var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[(!_vm.hideName)?[_c('b',[_vm._v(_vm._s(_vm.name))]),_c('br')]:_vm._e(),_vm._v(" "),_vm._l(((_vm.value || [])),function(skill){return _c('span',{key:skill,staticClass:"skill-tag mr-1 mt-1",style:({ backgroundColor: _vm.backgroundColor || '#eee' })},[_vm._v(_vm._s(skill))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa7d1c04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/JobSkillsShow.vue
// module id = SwL+
// module chunks = 0 112